var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50002 0.666626C3.90002 0.666626 0.166687 4.39996 0.166687 8.99996C0.166687 13.6 3.90002 17.3333 8.50002 17.3333C13.1 17.3333 16.8334 13.6 16.8334 8.99996C16.8334 4.39996 13.1 0.666626 8.50002 0.666626ZM8.50002 15.6666C4.82502 15.6666 1.83335 12.675 1.83335 8.99996C1.83335 5.32496 4.82502 2.33329 8.50002 2.33329C12.175 2.33329 15.1667 5.32496 15.1667 8.99996C15.1667 12.675 12.175 15.6666 8.50002 15.6666ZM6.83335 10.8083L12.325 5.31663L13.5 6.49996L6.83335 13.1666L3.50002 9.83329L4.67502 8.65829L6.83335 10.8083Z",
    fill: "#576B75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.fef177d45ce3cfaec29e55a1022bb455.svg";
export { ForwardRef as ReactComponent };